module.exports = __webpack_public_path__ + "img/vault.4ad94c8a.png";